import type { Ancestor } from "@/entities/ancestor";

import { getOrganizationAncestor } from "@/entities/ancestor";

export const getOrganizationSelectOptionValue = (ancestors: Ancestor[]) => {
  const organization = getOrganizationAncestor(ancestors);

  if (!organization) return undefined;

  return {
    value: organization.id,
    label: organization.name,
    key: organization.id,
  };
};
